"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateAllowedComparisons = exports.NumberAllowedComparisons = exports.StringAllowedComparisons = exports.ComparisonType = exports.FilterType = exports.isFilterDatasourceConfigRequest = exports.isFilterDatasourceConfig = void 0;
const isFilterDatasourceConfig = (cfg) => {
    return (cfg !== null &&
        'filter_type' in cfg &&
        'groups' in cfg &&
        'tab_id' in cfg &&
        'result_column_ids' in cfg);
};
exports.isFilterDatasourceConfig = isFilterDatasourceConfig;
const isFilterDatasourceConfigRequest = (cfg) => {
    return 'filter_type' in cfg && 'groups' in cfg && 'tab_id' in cfg && 'result_column_ids' in cfg;
};
exports.isFilterDatasourceConfigRequest = isFilterDatasourceConfigRequest;
var FilterType;
(function (FilterType) {
    FilterType["AND"] = "AND";
    FilterType["OR"] = "OR";
})(FilterType = exports.FilterType || (exports.FilterType = {}));
var ComparisonType;
(function (ComparisonType) {
    ComparisonType["CT"] = "contains";
    ComparisonType["NCT"] = "..";
    ComparisonType["EQ"] = "==";
    ComparisonType["GT"] = ">";
    ComparisonType["LT"] = "<";
    ComparisonType["GTE"] = ">=";
    ComparisonType["LTE"] = "<=";
    ComparisonType["NEQ"] = "!=";
    ComparisonType["IN"] = "in";
})(ComparisonType = exports.ComparisonType || (exports.ComparisonType = {}));
exports.StringAllowedComparisons = new Set([
    ComparisonType.CT,
    ComparisonType.NCT,
    ComparisonType.EQ,
    ComparisonType.NEQ,
    ComparisonType.IN,
]);
exports.NumberAllowedComparisons = new Set([
    ComparisonType.EQ,
    ComparisonType.NEQ,
    ComparisonType.GT,
    ComparisonType.GTE,
    ComparisonType.LT,
    ComparisonType.LTE,
    ComparisonType.IN,
]);
exports.DateAllowedComparisons = exports.NumberAllowedComparisons;
